import { computed, nextTick, ref, Ref, watch, WatchStopHandle } from 'vue';
import { IMultiSelect } from '@studyportals/multiselect/dist/src/interfaces/multiselect.interface';
import { IOption } from '@studyportals/multiselect/dist/src/interfaces/options.interface';
import { CampaignType } from '@studyportals/campaign-management-api-interface';
import { ValidationProperties } from '@/models/validation.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class CampaignTypeCode {
	public campaignTypeDropdown: Ref<IMultiSelect | null> = ref(null);
	public options: IOption[] = [
		{ label: 'Listing campaign', value: CampaignType.LISTING_PRODUCTS },
		{ label: 'Custom-products-only campaign', value: CampaignType.CUSTOM_PRODUCTS }
	];
	private unwatch: WatchStopHandle | null = null;

	public nameOfSelectedCampaignType = computed((): string => {
		const selectedOption = this.options.find((option) => option.value === this.campaignType.value);
		return selectedOption ? selectedOption.label : 'Not available';
	});

	public isCampaignTypeCustomProductsOnly = computed((): boolean => {
		return this.campaignType.value === CampaignType.CUSTOM_PRODUCTS;
	});

	public isCampaignCreation = computed((): boolean => {
		return store.getters.isCampaignCreation();
	});

	public campaignType = computed((): CampaignType | null => {
		return store.getters.campaignType();
	});

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.CAMPAIGN_TYPE);
	});

	private isCampaignTypeSet = computed((): boolean => {
		return this.campaignType.value !== null;
	});

	public mounted(): void {
		this.unwatch = watch(this.isLoading, this.prefillCampaignType.bind(this));
		void this.prefillCampaignType();
	}

	public unmounted(): void {
		if (!this.unwatch) {
			return;
		}

		this.unwatch();
	}

	public setCampaignType(option: IOption): void {
		store.mutations.setCampaignType(option.value as CampaignType);

		if (!this.isFieldValidatedAndMissing.value) {
			return;
		}

		validationPresenter.validateMandatoryFields();
	}

	private async prefillCampaignType(): Promise<void> {
		if (this.isLoading.value) {
			return;
		}

		await nextTick();

		if (!this.campaignTypeDropdown.value || !this.isCampaignTypeSet.value) {
			return;
		}

		const selectedOption = this.options.find((option) => option.value === this.campaignType.value);
		if (!selectedOption) {
			return;
		}

		this.campaignTypeDropdown.value.selectOption(selectedOption);
	}
}
